export default "__VITE_ASSET__BOvENR8B__"